/**
 * An enumerable collection of all available interaction events
 * to be sent to Google Analytics.
 *
 * NB: The inconsistency in choice of events and values is due to the
 * fact that these have been provided to us by product. Going forward
 * we should be able to decide on our own list of events and naming
 * convention.
 */

enum InteractionType {
    ENTER_FULLSCREEN = 'fullscreen',
    EXIT_FULLSCREEN = 'exitFullscreen',
    FAST_FORWARD = 'fastforward',
    LIVE_INDICATOR_CLICK = 'liveIndicatorClick',
    MUTE = 'mute',
    PAUSE = 'pause',
    PLAY = 'play',
    REWIND = 'rewind',
    SEEK_BACKWARD = 'barClickBackward',
    SEEK_FORWARD = 'barClickForward',
    TIMECODE_CLICK = 'timeCodeClick',
    UNMUTE = 'unmute',
    VOLUME_DOWN = 'volumeDown',
    VOLUME_UP = 'volumeUp'
}

export default InteractionType;